import { ContentType } from "@dimensional-engineering/dimensional-models";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

import styles from "./TwoByTwoDeltaView.module.css";

import { TwoByTwoNewPreviousScore } from "@/components/shared/TwoByTwoNew/TwoByTwoNew";
import { useStaggeredOpacity } from "@/helpers/useStaggeredOpacity";
import ThemedButton from "@/components/shared/ThemedButton/ThemedButton";

export default function TwoByTwoDeltaView(props: { slug: string, onFinish: () => void }) {
  const userState = useSelector((state: RootState) => state.user);

  const opacity = useStaggeredOpacity(4);

  return (
    <div className={styles.main}>
      <p style={{ opacity: opacity.step1 }} className={styles.topText}>
        CHANGES
      </p>
      <div style={{ opacity: opacity.step2 }} className={styles.twoByTwoDiv}>
        <TwoByTwoNewPreviousScore
          contentIdentifier={{
            contentSlug: props.slug,
            contentType: ContentType.dimensionSummary,
          }}
          imageUrl={userState.imageURL ?? ""}
          publicProfile={userState.publicProfileData}
        />
      </div>
      <p style={{ opacity: opacity.step3 }} className={styles.bottomText}>
        {"Here's how you've changed."}
      </p>
      <div
        onClick={(e) => {
          e.stopPropagation();
          props.onFinish();
        }}
        style={{ opacity: opacity.step4 }}
        className={styles.bottomButton}
      >
        <ThemedButton
          style={{ fontWeight: "450", width: "100%" }}
          title="Continue to breakdown"
        />
      </div>
    </div>
  );
}
